import { render } from "./AposInputArea.vue?vue&type=template&id=844370c8&scoped=true"
import script from "./AposInputArea.vue?vue&type=script&lang=js"
export * from "./AposInputArea.vue?vue&type=script&lang=js"

import "./AposInputArea.vue?vue&type=style&index=0&id=844370c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844370c8"],['__file',"schema/ui/apos/components/AposInputArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "844370c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('844370c8', __exports__)) {
    api.reload('844370c8', __exports__)
  }
  
  module.hot.accept("./AposInputArea.vue?vue&type=template&id=844370c8&scoped=true", () => {
    api.rerender('844370c8', render)
  })

}


export default __exports__